// arrow up icon
import { useEffect } from 'react';
import { ImArrowUp } from 'react-icons/im';

// ****** scroll to top button *****
export const GoToTopBtn = () => {
    useEffect(() => {
        const checkScroll = () => {
            if (window.scrollY > 140) {
                let el = document.getElementById("scrollToTop");
                if (el) {
                    el.classList.add("show-top")
                }
            } else {

                let el = document.getElementById("scrollToTop");
                if (el) {
                    el.classList.remove("show-top")
                }
            }
            // header
            if (window.scrollY > 60) {
                let el1 = document.getElementById("web-header");
                if (el1) {
                    el1.classList.add("header-active")
                }
            } else {

                let el1 = document.getElementById("web-header");
                if (el1) {
                    el1.classList.remove("header-active")
                }
            }
        };


        window.addEventListener("scroll", checkScroll);

        return () => {
            window.removeEventListener("scroll", checkScroll);
        }
    }, [])
    // 
    const go = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    // 
    return (
        <div onClick={go} className="go-to-top" id="scrollToTop">
            <ImArrowUp />
        </div>
    )
}